import { FunctionComponent } from 'preact';
import { useDispatch, useSelector } from 'react-redux';
import { css } from '../../../../../common/styles/styles.utils';
import { MORE_VIDEOS_PLUGIN_MORE_VIDEOS_TEXT } from '../../../moreVideos.constants';
import { Icon } from '../../../../../common/components/icon/icon';
import { COMMON_ICON_TYPES } from '../../../../../common/components/icon/iconMapper';
import { getSmallGalleryCloseButtonId } from '../../../htmlElements/htmlElementsIdGetter';
import { setShowGalleryView, setUserInteraction } from '../../../store/moreVideos.actions';
import { playerDataSelector } from '../../../../../common/store/selectors/playerData.selector';
import { useStyles } from '../../../../../common/hooks/useStyles';
import { getVideoHeaderStyleObject } from './videoHeader.style';

const ARIA_LABEL = 'Close more videos';

interface VideoHeaderVariablesProps {
    setExitGalleryView: (value: boolean) => void;
    isEndState: boolean;
}

export const VideoHeader: FunctionComponent<VideoHeaderVariablesProps> = props => {
  const { setExitGalleryView, isEndState } = props;

  const dispatch = useDispatch();
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);

  const styles = useStyles(getVideoHeaderStyleObject, [isEndState]);
  const { headerStyle, moreVideosTitleStyle, closeIconStyle } = styles;

  const onClickCloseIcon = (): void => {
    dispatch(setUserInteraction('moreVideosClosed'));
    dispatch(setShowGalleryView(false));
    setExitGalleryView(true);
  };

  return (
    <div style={headerStyle}>
      <span style={css(moreVideosTitleStyle)}>
        {MORE_VIDEOS_PLUGIN_MORE_VIDEOS_TEXT}
      </span>
      { !isEndState
            && (
              <Icon
                icon={COMMON_ICON_TYPES.CLOSE_FILL}
                style={closeIconStyle}
                onClick={onClickCloseIcon}
                id={getSmallGalleryCloseButtonId(playerUniqueId)}
                ariaLabel={ARIA_LABEL}
              />
            )}
    </div>
  );
};
